import React, { useState, useEffect, useContext } from "react";
import { Col } from "react-bootstrap";
import Select from "react-select";
import data from "../../data.json";
import Context from "../../Context";

const ConcluDiagnos = () => {
  const { showIcons } = useContext(Context);

  const localEsfera = JSON.parse(localStorage.getItem("localEsfera"));
  const [esfera, setEsfera] = useState(localEsfera);

  const localPatronBase = JSON.parse(localStorage.getItem("localPatronBase"));
  const [cadena, setCadena] = useState(localPatronBase);

  const options0 = [
    { value: "Cráneo", label: "Cráneo" },
    { value: "Tórax", label: "Tórax" },
    { value: "Pelvis", label: "Pelvis" },
    { value: "Pie", label: "Pie" },
    { value: "", label: "" },
  ];

  const options1 = [
    { value: "Apertura", label: "Apertura" },
    { value: "Cierre", label: "Cierre" },
    { value: "Extensión", label: "Extensión" },
    { value: "Flexión", label: "Flexión" },
    { value: "Inspiración", label: "Inspiración" },
    { value: "Espiración", label: "Espiración" },
    { value: "", label: "" },
  ];

  // handle change event of the esfera dropdown
  const handleEsferaChange = (value) => {
    setEsfera(value);
    localStorage.setItem("localEsfera", JSON.stringify(value));
  };

  // handle change event of the cadena dropdown
  const handleCadenasChange = (value) => {
    setCadena(value);
    localStorage.setItem("localPatronBase", JSON.stringify(value));
  };

  const handleDeleteAll = () => {
    setEsfera(null);
    setCadena(null);
    
    setTimeout(() => {
      localStorage.removeItem("localEsfera", "localPatronBase");
    }, 2000);
    
  };

  return (
    <>
      <div className="column">
        <div className="card-section">
          <div style={{ /*  width: 400, */ margin: 20 }}>
            <h4 className="text-center">Conclusión Diagnóstica</h4>
            <br />
            <h6>Esfera++</h6>
            <Select
              className="react-select__option"
              placeholder="Seleccione la Esfera"
              value={esfera}
              options={options0}
              onChange={handleEsferaChange}
              /* getOptionLabel={(x) => x.esfera} */
              /* getOptionValue={(x) => x.esfera_code} */
            />
            <br />

            <h6>Cadena o Patrón de Base</h6>
            <Select
              className="react-select__option mb-4"
              placeholder="Seleccione la Cadena"
              value={cadena}
              options={options1}
              onChange={handleCadenasChange}
              /* getOptionLabel={(x) => x} */
              /* getOptionValue={(x) => x.code} */
            />
            {/* <img
            className="icon-estrella"
            src="/assets/images/estrellaTEST.png"
            alt="estrella CMF"
            onClick={() => console.log("hello")}
          /> */}
          </div>
        </div>
        {showIcons && (
          <div className="icons-card-canvas mb-5">
            <img
              className="icon-trash-canvas"
              src="/assets/images/trash.png"
              alt="icon-image"
              onClick={handleDeleteAll}
            />
            {/* <img
            className="icon-trash-canvas"
            src="/assets/images/icon-download.png"
            alt="icon-image"
            onClick={() => alert("Imagen guardada")}
          /> */}
          </div>
        )}
      </div>
    </>
  );
};

export default ConcluDiagnos;
